export class StudyMetadataSource {
  getByInstanceUID() {}

  loadStudy() {}
}
